import { Component } from "@angular/core";

@Component({
    selector: "app-birdietime-integration",
    templateUrl: "./birdietime-integration.component.html"
})
export class BirdietimeIntegrationComponent {

}